import * as React from "react";
import { EarthEngine } from "../../earth/earthEngine";
import { FrameTime } from "../../earth/earthEngine";
import { Country } from "../../earth/model/country";
import { LandLevel } from "../../earth/model/land";
import { Button } from "./button";
import { UIContext } from "./uiContext";
import { UIContextAttractMode } from "./uiContextAttractMode";
import { UIContextCanTimeout } from "./uiContextCanTimeout";
import { UIContextNavigation } from "./uiContextNavigation";
import { UIGlobalState } from "./uiGlobalState";

export class UIContextDetails extends UIContext {   //  *** This class should be a UIContextCanTimeout but due to a bug it can't and we had do copy/past the content of UIContextCanTimeout
    _onMoveId = -1;

    //  *** From UIContextCanTimeout
    static readonly MaxInactiveTime = 30.0;
    private _inactiveTime: number = 0;
    private _onScreenTouched: number = -1;

    get landLevel(): LandLevel {
        return LandLevel.Country;
    }

    get selectedCountry(): Country | null {
        return this.country;
    }

    constructor(public country: Country) {
        super();
        this.onBackButtonClicked = this.onBackButtonClicked.bind(this);
    }

    enter(from: UIContext) {
        super.enter(from);
        EarthEngine.instance.interactionManager.highlightCountry(this.country);
        EarthEngine.instance.interactionManager.focusCameraOnLand(this.country);
        EarthEngine.instance.brightness = 1.0;
        this._onMoveId = EarthEngine.instance.camera.onMove.connect(() => { this.shouldSwitchToContext.emit(new UIContextNavigation()); });

        //  *** From UIContextCanTimeout
        this._onScreenTouched = EarthEngine.instance.interactionManager.screenTouched.connect(() => { this._inactiveTime = 0; });
    }

    leave(to: UIContext) {
        if (this._onMoveId >= 0) {
            EarthEngine.instance.camera.onMove.disconnect(this._onMoveId);
            this._onMoveId = -1;
        }
        EarthEngine.instance.brightness = 1.0;
        EarthEngine.instance.interactionManager.highlightCountry(null);

        //  *** From UIContextCanTimeout
        if (this._onScreenTouched >= 0) {
            EarthEngine.instance.interactionManager.screenTouched.disconnect(this._onScreenTouched);
            this._onScreenTouched = -1;
        }

        super.leave(to);
    }

    render(globalState: UIGlobalState): JSX.Element {
        return <div>
            {super.render(globalState)}

            <div style={{ position: "absolute", left: 100, bottom: 60 }}>
                <Button className="back-button" normalImgSrc="assets/app/images/button-back.png" onClicked={this.onBackButtonClicked}/>
            </div>

            <div className="country-name">{this.country.name}</div>
        </div>;
    }

    onEarthTapped(country: Country | null) {
        super.onEarthTapped(country);
        if (country) {
            this.shouldSwitchToContext.emit(new UIContextDetails(country));
        } else {
            this.onBackButtonClicked();
        }
    }

    onSkyTapped() {
        super.onSkyTapped();
        this.onBackButtonClicked();
    }

    private onBackButtonClicked() {
        this.shouldSwitchToContext.emit(new UIContextNavigation());
        EarthEngine.instance.camera.focusHeight(2.0);
    }

    //  *** From UIContextCanTimeout
    update(time: FrameTime) {
        super.update(time);
        this._inactiveTime += time.deltaTime;
        if (this._inactiveTime > UIContextCanTimeout.MaxInactiveTime) {
            this.shouldSwitchToContext.emit(new UIContextAttractMode());
        }
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--1!./src/app/ui/uiContextDetails.tsx